import drawText from "./drawText";

const drawScaleTexts = (x, y, orir, orr, onePartSize, rotation, scales, colors, textIds) => {
    const elements = [];
    scales.map((scale, index) => {
        const id = scale.text.bottom ? textIds.bottomTextId : textIds.topTextId;
        const outerRingTextColor = scales[index].score > 3 ? colors.white : colors.black;
        elements.push(
            drawText(
                colors, scale.text.text, id, scale.text.offset, 20, outerRingTextColor
            )
        );
        scale.subscales.map(subscale => {
            subscale.text.map((text, index) => {
                let subId;
                if (index === 0) {
                    subId = scale.text.bottom ?
                        textIds.innerBottomTextId : textIds.innerTopTextId;
                } else {
                    subId = scale.text.bottom ?
                        textIds.innerBottomTextLine2Id : textIds.innerTopTextLine2Id;
                }
                elements.push(drawText(colors, text.text, subId, text.offset, 12));
            });
        });
    });
    return elements;
};

export default drawScaleTexts;
